import Inputs from './Component/inputs/Inputs';

import './App.css';

function App() {
  return (
    <>
      <div className='todoApp'>
        <Inputs />
      </div>
    </>
  );
}

export default App;
